import styled from '@emotion/styled'
import { useEffect, useState } from 'react'
import Breakpoint from '../../Breakpoint'
import { useLangSelected } from '../../hooks/useLangSelected'
import apiClient from '../../services/apiClient'
import { serverFile } from '../../services/file.service'

const Carousel = () => {
    const lng = useLangSelected()
    const [partners, setPartners] = useState<any[]>([])

    useEffect(() => {
        apiClient
            .post('/partners/all', { lng })
            .then(({ data }) => {
                setPartners(data)
            })
            .catch((err) => {
                console.error('Error fetching partners:', err)
            })
    }, [lng])

    if (partners.length === 0) return null

    return (
        <MainCarouselContainer data-testid="carousel">
            <CarouselContainer>
                <CarouselWrapper className="carousel-1">
                    {partners.map((partner, index) => (
                        <Partner
                            key={'partner1-' + partner.name + index}
                            href={partner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={partner.logo ? serverFile(partner.logo) : ''} alt={partner.name} />
                        </Partner>
                    ))}
                </CarouselWrapper>
                <CarouselWrapper className="carousel-2">
                    {partners.map((partner, index) => (
                        <Partner
                            key={'partner2-' + partner.name + index}
                            href={partner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={partner.logo ? serverFile(partner.logo) : ''} alt={partner.name} />
                        </Partner>
                    ))}
                </CarouselWrapper>
                <CarouselWrapper className="carousel-3">
                    {partners.map((partner, index) => (
                        <Partner
                            key={'partner3-' + partner.name + index}
                            href={partner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={partner.logo ? serverFile(partner.logo) : ''} alt={partner.name} />
                        </Partner>
                    ))}
                </CarouselWrapper>
            </CarouselContainer>
        </MainCarouselContainer>
    )
}

const MainCarouselContainer = styled.div`
    overflow: hidden;
    width: 100%;
    box-shadow: 0px 0px 6px black;
`

const CarouselContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300%;

    @media (max-width: ${Breakpoint.TABLET_L}) {
        width: 400%;
    }

    @media (max-width: ${Breakpoint.TABLET_XS}) {
        width: 600%;
    }

    @media (max-width: ${Breakpoint.PHONE}) {
        width: 950%;
    }
`

const CarouselWrapper = styled.div`
    display: flex;
    justify-content: space-around;

    background-color: white;

    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }

    -ms-scroll-chaining: none;
    -webkit-scroll-snap-type: x mandatory;

    width: 100%;
    animation: carousel 15s linear infinite;

    @keyframes carousel {
        0% {
            transform: translateX(0%);
        }
        100% {
            transform: translateX(-100%);
        }
    }
`

const Partner = styled.a`
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 10px;

    img {
        max-height: 75px;
    }
`

export default Carousel
